import { lazy, Suspense } from "react";
import { Link, useParams } from "react-router-dom";
import "./games.css";
import Discussion, { ShareButton } from '../components/Discussion';

const Snake = lazy(() => import("../Games/SnakeGame"));
const TicTacToe = lazy(() => import("../Games/TicTacToe/TicTacToe"));
const InverseSnake = lazy(() => import("../Games/InverseSnake/PlayInverseSnake"));
const games = [
  { id: "snake", title: "Snake", description: "An old-school appetite for trouble.", instructions: "Use the arrow keys to steer. Collect food and avoid the walls.", component: Snake },
  { id: "tic-tac-toe", title: "Tic Tac Toe", description: "Two players. Nine squares. One grudge match.", instructions: "Take turns with a friend. Get three marks in a row to win.", component: TicTacToe },
  { id: "inverse-snake", title: "Inverse Snake", description: "A different kind of snake problem.", instructions: "Click inside the game to give it keyboard focus.", component: InverseSnake },
];

export default function Games() {
  const { gameId } = useParams();
  const game = games.find((item) => item.id === gameId);
  if (gameId && !game) return <main className="games-page"><h1>Game not found</h1><Link to="/games">Back to the arcade</Link></main>;
  if (game) {
    const Game = game.component;
    return <main className="games-page"><Link to="/games">← All games</Link><h1>{game.title}</h1><p>{game.instructions}</p><Suspense fallback={<p role="status">Loading game…</p>}><Game key={game.id} /></Suspense><ShareButton title={game.title} /><Discussion key={game.id} item={{ ...game, type: 'games' }} /></main>;
  }
  return <main className="games-page"><p className="eyebrow">Insert absolutely no coins</p><h1>The arcade</h1><p>A little friendly chaos. Pick a game and make yourself at home.</p><div className="game-header">{games.map((item) => <article className="game-card" key={item.id}><h2>{item.title}</h2><p>{item.description}</p><Link className="comic-link" to={`/games/${item.id}`}>Play {item.title}</Link></article>)}</div></main>;
}
